import * as API from "../ApiConfig";

export default {
  checkAffiliatesCampaign(_input) {
    return API.peakAffiliatesConnect
      .post("/affiliate-campaign/check-active-campaign", {
        ..._input
      })
      .then(res => {
        return {
          data: res.data.data,
          code: res.data.statusCode
        };
      })
      .catch(err => {
        return {
          message: err.response.data.message,
          code: err.response.data.statusCode,
          prop: err.response.data.prop
        };
      });
  },
  createUserCampaign(_input) {
    return API.peakAffiliatesConnect
      .post("/user-campaign/create-user-campaign", {
        ..._input
      })
      .then(res => {
        return {
          data: res.data.data,
          code: res.data.statusCode
        };
      })
      .catch(err => {
        return {
          message: err.response.data.message,
          code: err.response.data.statusCode,
          prop: err.response.data.prop
        };
      });
  },
  getCampaignPreview(_input) {
    return API.peakAffiliatesConnect
      .post("/affiliate-campaign/get-preview", {
        ..._input
      })
      .then(res => {
        return {
          code: res.data.statusCode,
          data: {
            uploadImage: res.data.data.uploadImage,
            affiliatePromoTextTh: res.data.data.affiliatePromoteTextTh,
            affiliatePromoteSubTextTh: res.data.data.affiliatePromoteSubTextTh,
            descriptionAffiliateTh: res.data.data.descriptionAffiliateTh,
            affiliatePromoteTextEn: res.data.data.affiliatePromoteTextEn,
            affiliatePromoteSubTextEn: res.data.data.affiliatePromoteSubTextEn,
            descriptionAffiliateEn: res.data.data.descriptionAffiliateEn,
          }
        };
      })
      .catch(err => {
        return {
          message: err.response.data.message,
          code: err.response.data.statusCode,
          prop: err.response.data.prop
        };
      });
  },
  actionRegister(_input) {
    return API.peakAffiliatesConnect
      .post("/action-detectors/register", {
        ..._input
      })
      .then(res => {
        return {
          data: res.data.data,
          code: res.data.statusCode
        };
      })
      .catch(err => {
        return {
          message: err.response.data.message,
          code: err.response.data.statusCode,
          prop: err.response.data.prop
        };
      });
  }
};
